export const API_URL = "https://carcounter.modulosys.com";
export const API_PORT = 443;